import * as Types from '../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type GetSharedDrivesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSharedDrivesQuery = { __typename?: 'QueryModel', projectFolders: { __typename?: 'ProjectFoldersQueryModel', drives: Array<{ __typename?: 'SharedDrive', driveLetter: string, physicalLocation: string }> } };


export const GetSharedDrivesDocument = gql`
    query getSharedDrives {
  projectFolders {
    drives {
      driveLetter
      physicalLocation
    }
  }
}
    `;

/**
 * __useGetSharedDrivesQuery__
 *
 * To run a query within a React component, call `useGetSharedDrivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedDrivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedDrivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSharedDrivesQuery(baseOptions?: Apollo.QueryHookOptions<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>(GetSharedDrivesDocument, options);
      }
export function useGetSharedDrivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>(GetSharedDrivesDocument, options);
        }
export type GetSharedDrivesQueryHookResult = ReturnType<typeof useGetSharedDrivesQuery>;
export type GetSharedDrivesLazyQueryHookResult = ReturnType<typeof useGetSharedDrivesLazyQuery>;
export type GetSharedDrivesQueryResult = Apollo.QueryResult<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>;